export default function initialState() {
    return {
        courses: {
            __loading__: false,
            __error__: null
        }
    };
}
